/**
   *  Hình thức giao
   */
export default {
  Online: 1, // trực tuyến
  Offline: 2 // truyền thống
};